import { render, staticRenderFns } from "./Guidelines.vue?vue&type=template&id=257b2f49&scoped=true&"
import script from "./Guidelines.vue?vue&type=script&lang=js&"
export * from "./Guidelines.vue?vue&type=script&lang=js&"
import style0 from "./Guidelines.vue?vue&type=style&index=0&id=257b2f49&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257b2f49",
  null
  
)

export default component.exports